import ecommEndpoints from "../../features/endPoints/ecommEndpoints";
import BaseClient from "../base/baseClient";

const OtPaymentAuthorizationClient = (requestBody) => {
  const { post: postClient } = BaseClient();
  
  return postClient(
    process.env.REACT_APP_ECOMM_URL + ecommEndpoints.OTpaymentAuthorization(),
    requestBody,
    {},
    true
  );
};

//map response to object needed by React view
const mapResponse = (response) => {
  return response;
};

//map error to object needed by React view
const mapError = (error) => {
  return error;
};

export default OtPaymentAuthorizationClient;
